<template>
  <div class="app-container feedback">
    <div class="header">
      <el-input
        placeholder="昵称"
        v-model="listQuery.nickname"
        :clearable="true"
        style="width: 200px;margin: 0 15px;"></el-input>
      <el-input
        placeholder="联系电话"
        v-model="listQuery.phone"
        :clearable="true"
        style="width: 200px;margin: 0 15px;"></el-input>
      <el-select
        placeholder="请选择状态"
        v-model="listQuery.handled"
        :clearable="true"
        style="margin-right: 15px;">
        <el-option label="未处理" value="0"></el-option>
        <el-option label="已处理" value="1"></el-option>
      </el-select>
      <el-button size="small" type="primary" @click="search">搜索</el-button>
    </div>
    <el-table
      :loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="margin-top: 15px;"
    >
      <el-table-column label="序号" align="center" width="95">
        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
      </el-table-column>
      <el-table-column label="头像" align="center" min-width="150">
        <template slot-scope="scope">
          <img
            v-if="scope.row.user.avatar"
            :src="scope.row.user.avatar"
            alt=""
            style="width: 110px"
          />
        </template>
      </el-table-column>
      <el-table-column label="昵称" align="center" min-width="110">
        <template slot-scope="scope">{{ scope.row.user.nickname }}</template>
      </el-table-column>
      <el-table-column label="联系电话" align="center" min-width="110">
        <template slot-scope="scope">{{ scope.row.user.phone }}</template>
      </el-table-column>
      <el-table-column label="反馈" align="center" min-width="200">
        <template slot-scope="scope">{{ scope.row.content }}</template>
      </el-table-column>
      <el-table-column label="是否已处理" align="center" min-width="95">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.handled">已处理</el-tag>
          <el-tag type="info" v-else>未处理</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="300">
        <template slot-scope="scope">
          <el-button size="small" @click="handleShowInfo(scope.row)"
            >查看详情</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="handleFeedback(scope.row)"
            v-if="!scope.row.handled"
            >处理</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        :current-page="listQuery.page"
        :page-size="listQuery.limit"
        :page-sizes="[5, 10, 20, 30, 50]"
        :total="total"
        background
        layout="total,sizes,prev,pager,next,jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <el-dialog v-if="showDialog" :visible.sync="showDialog" title="反馈详情">
      <el-form label-width="50px">
        <el-form-item label="昵称">
          <div style="width:500px;">{{ showContent.user.nickname }}</div>
        </el-form-item>
        <el-form-item label="头像">
          <img :src="showContent.user.avatar" alt="" width="100px">
        </el-form-item>
        <el-form-item label="电话">
          <div style="width:500px;">{{ showContent.user.phone }}</div>
        </el-form-item>
        <el-form-item label="内容">
          <div style="width:500px;">{{ showContent.content }}</div>
        </el-form-item>
        <el-form-item label="图片">
          <div class="images">
            <el-image 
              :preview-src-list="showContent.images"
              class="imgs"
              v-for="item in showContent.images"
              :key="item"
              :src="item"
            ></el-image>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  data() {
    return {
      listLoading: false,
      total: 1,
      listQuery: {
        page: 1,
        limit: 5,
        handled:'',
        nickname:'',
        phone:''
      },
      list: [],
      showDialog: false,
      showContent: null
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/feedback",
        method: "get",
        params: this.listQuery
      })
        .then(result => {
          this.list = result.data.data;
          this.total = result.data.total;
          this.listLoading = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    search(){
      this.listQuery.page = 1;
      this.getList();
    },
    feedBack(row) {
      request({
        url: "/api/backend/feedback/handled",
        method: "post",
        data: { id: row.id }
      }).then(result => {
          this.$notify.success("操作成功");
          this.getList();
        })
        .catch(err => {
          this.$notify.error("操作失败");
        })
        .finally(() => {
          this.showRefuse = false;
        });
    },
    handleFeedback(row) {
      this.$confirm("此操作将会处理该反馈内容，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(result => {
          this.feedBack(row)
        })
        .catch(err => {
          this.$notify.info("已取消");
        });
    },
    handleShowInfo(row) {
      this.showDialog = true;
      this.showContent = row;
    }
  }
};
</script>

<style>
.introduction {
  width: 500px;
}
.images {
  width: 500px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.imgs {
  width: 150px;
  height: 150px;
  margin-right: 20px;
  margin-bottom: 20px;
}
.imgs:nth-child(3n) {
  margin-right: 0px;
}
</style>
